import type { UserManagerSettings } from 'oidc-client-ts';

const issuer = import.meta.env.VITE_KC_ISSUER || 'http://voice.test/auth/realms/tree';
const clientId = import.meta.env.VITE_KC_CLIENT_ID || 'voice-dashboard';

export const oidcConfig: UserManagerSettings = {
  authority: issuer,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/login/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  loadUserInfo: false,
};
